// import ExecuteReport from '../features/query-builder-new/execute-report';
// import QueryBuilderPage from '../features/query-builder-new/query-builder.page';

import ExecuteReport from '../features/query-builder/execute-report';
import QueryBuilderPage from '../features/query-builder/query-builder.page';

export const QueryBuilderRoute = {
  path: '/custom-builder',
  name: 'Custom Report',
  children: [
    {
      index: true,
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_INVOICE_REPORTS]} showPermissionError>
        <QueryBuilderPage />
        // </GuardedComponent>
      ),
    },
    {
      path: 'execute-report/:reportName',
      name: 'report',
      element: <ExecuteReport />,
    },
    {
      path: 'edit/:id',
      name: 'report',
      element: <QueryBuilderPage />,
    },
  ],
};
